import React, { CSSProperties } from "react";
import cx from "classnames";
import styles from "./fieldset-content.module.scss";

export interface IFieldsetContent {
  children?: React.ReactNode;
  className?: string;
  style?: CSSProperties;
  htmlId?: string;
}

export const FieldsetContent = (props: IFieldsetContent) => {
  return (
    <div className={cx(styles.fieldset_content, props.className)} style={props.style} id={props.htmlId}>
      {props.children}
    </div>
  );
};

FieldsetContent.defaultProps = {};
